import { h } from 'preact';
import { useState, useEffect } from 'preact/hooks';
import { TextCheckboxList } from './TextCheckboxList';
import { RatingCheckboxList } from './RatingCheckboxList';
import { ColorSwatch } from './ColorSwatch';
import { RangeSlider } from './RangeSlider';
import { CollapsibleToggle } from './CollapsibleToggle';
export function Filter({ filter, onFilterChange, isFirst = false, }) {
    const [isMobile, setIsMobile] = useState(false);
    // Check if we're on mobile with proper state management
    useEffect(() => {
        const checkMobile = () => {
            setIsMobile(window.innerWidth <= 768);
        };
        checkMobile();
        window.addEventListener('resize', checkMobile);
        return () => window.removeEventListener('resize', checkMobile);
    }, []);
    const isColorFilter = () => {
        const colorKeywords = [
            'v_meta_colour_group_uFilter',
            'pf_m_::bac::colour_group',
        ];
        return colorKeywords.some((keyword) => filter.id.includes(keyword) || filter.id.includes(keyword));
    };
    const renderFilter = () => {
        switch (filter.type) {
            case 'text':
            case 'select':
                if (isColorFilter()) {
                    return (h(ColorSwatch, { options: filter.options || [], onChange: (value) => onFilterChange(filter.id, value), selectType: filter.selectType }));
                }
                return (h(TextCheckboxList, { options: filter.options || [], onChange: (value) => onFilterChange(filter.id, value), facetName: filter.label, selectType: filter.selectType }));
            case 'color':
                return (h(ColorSwatch, { options: filter.options || [], onChange: (value) => onFilterChange(filter.id, value), selectType: filter.selectType }));
            case 'rating':
                return (h(RatingCheckboxList, { options: filter.options || [], onChange: (value) => onFilterChange(filter.id, value) }));
            case 'range':
                return (h(RangeSlider, { min: filter.min || 0, max: filter.max || 1000, gap: 0, currentMin: filter.currentMin || filter.min || 0, currentMax: filter.currentMax || filter.max || 1000, onChange: (values) => {
                        const formattedValue = `${values[0]}:${values[1]}`;
                        onFilterChange(filter.id, formattedValue);
                    } }));
            default:
                return null;
        }
    };
    return (h("div", { className: "filter" },
        h(CollapsibleToggle, { title: filter.label, defaultOpen: isFirst && !isMobile }, renderFilter())));
}
